import React from "react";
import {
    TextSortAscendingRegular,
    TextSortDescendingRegular,
} from "@fluentui/react-icons";
import { Checkbox, Flex, Text } from "@fluentui/react-northstar";
import { useSortingData } from "../../stores/sorting.store";

const CellHeaderName = ({
    canSort = false,
    checked = false,
    disabled = false,
    onCheckAll = () => null,
}) => {
    const store_sort = useSortingData();
    return (
        <Flex gap="gap.smaller" vAlign="center">
            <Checkbox
                size="small"
                defaultChecked={checked}
                disabled={disabled}
                checked={checked}
                onChange={(e, { checked }) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onCheckAll(checked);
                }}
                styles={{ width: "20px" }}
            />
            <Text content="Nom" />
            {canSort &&
                (store_sort.sortByName === "asc" ? (
                    <TextSortAscendingRegular
                        color="var(--color-primary)"
                        cursor={"pointer"}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            store_sort.setSortByName(
                                store_sort.sortByName === "asc" ? "desc" : "asc"
                            );
                        }}
                    />
                ) : (
                    <TextSortDescendingRegular
                        color="var(--color-primary)"
                        cursor={"pointer"}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            store_sort.setSortByName(
                                store_sort.sortByName === "asc" ? "desc" : "asc"
                            );
                        }}
                    />
                ))}
        </Flex>
    );
};

export default CellHeaderName;
